module.exports = __webpack_public_path__ + "img/logo-avatar.13e0527a.png";